import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import language from '../../../assets/languages/language';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import Axios from 'axios';
import { renderHTMLContent } from '../../../common/function';
import Loader from '../../../common/loader';
import { showFailure, showSuccess } from '../../../common/toast';
import { localStorageKeys } from '../../../common/constant';
import userStore from "../../../store/userStore";

class ProfileInfo extends Component {
  state = {
    alert_status: false,
    avatarData: '',
    avatarURL: '',
    token: '',
    idname: '',
    email: '',
    userName: '',
    age: '',
    occupation: '',
    education: '',
    ValidToken: false,
    send_notification: '',
    user_id: '',
    username: '',
    toggleActive: false,
    storage_session: [],
    dropdownOpen: false,
    isLoading: true,
    isShowDeleteConfirmationModal: false,
    role: '',
    subscriptionDetails: [],
    isLoadingUpdateProfile: false,
  };

  static contextTypes = {
    router: React.PropTypes.object,
  };

  handleInputChange = (field) => (e) => {
    const { value } = e.target;
    if (field === 'age' && (isNaN(value) || value < 0)) return;
    this.setState({ [field]: value });
  };

  updateProfile = async () => {
    const {
      userName,
      email,
      age,
      occupation,
      education,
      avatarData,
      send_notification,
      idname,
      token,
    } = this.state;
    this.setState({ isLoadingUpdateProfile: true });
    const profilePayload = {
      userName,
      email,
      age,
      occupation,
      education,
      file: avatarData,
      send_notification,
      idname,
    };
    if (avatarData) {
      const formData = new FormData();
      Object.entries(profilePayload).forEach(([k, v]) => formData.append(k, v));

      try {
        const resp = await Axios.post(`${App_data.backend_api}/user/updateProfile`, formData, {
          headers: { Authorization: token },
        });
        if (resp.data.success) {
          showSuccess(language.LC().PROFILE_SUCCESSFULLY_UPDATED);
          this.props.setIsChildChangedTrue(true);
          this.setState({ isLoadingUpdateProfile: false }, () => {
            userStore.fetchProfile()
          });
        } else {
          this.setState({ isLoadingUpdateProfile: false });
          showFailure(language.LC().UPDATE_FAILED);
        }
      } catch (err) {
        showFailure(language.LC().UPDATE_FAILED);
      }
    } else {
      const data = {
        token: this.state.token,
        idname,
        newProfile: {
          userName,
          email,
          age,
          occupation,
          education,
          send_notification,
        },
      };
      const resp = await FD.callAPI(`${App_data.backend_api}/user/updateProfiledata`, data);
      if (resp.success) {
        showSuccess(language.LC().PROFILE_SUCCESSFULLY_UPDATED);
        this.setState({ isLoadingUpdateProfile: false });
        this.props.setIsChildChangedTrue(true);
      } else {
        this.setState({ isLoadingUpdateProfile: false });
        showFailure(language.LC().UPDATE_FAILED);
      }
    }
  };

  deleteAccount = async () => {
    const { token, user_id, role, idname, subscriptionDetails } = this.state;
    this.deleteAccountToggle();

    const data = { token, idname, id: user_id, role };

    // Cancel subscriptions if any
    if (subscriptionDetails && subscriptionDetails.length) {
      for (const {
        subscriptionId,
        subscriptionScheduleId,
        cancelledSubscription,
        package_id,
      } of subscriptionDetails) {
        if ((subscriptionId || subscriptionScheduleId) && !cancelledSubscription) {
          const cancelPayload = {
            token,
            idname,
            subscriptionId,
            subscriptionScheduleId,
            package_id,
          };
          await FD.callAPI(`${App_data.backend_api}/checkout_v1/cancelSubscription`, cancelPayload);
        }
      }
    }

    // Delete user only once after handling subscriptions
    const resp = await FD.callAPI(`${App_data.backend_api}/user/accountDelete`, data);
    if (resp.success) {
      await showSuccess(language.LC().ACCOUNT_DELETED_SUCCESSFULLY);
      this.clearLocalStorage();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isProfilePrivate !== this.state.isProfilePrivate) {
      this.setState({
        profileStatus: this.state.isProfilePrivate === 'private' ? 'Private' : 'Public',
      });
    }
    if (prevProps.avatarData !== this.props.avatarData) {
      this.setState({ avatarData: this.props.avatarData });
    }
  }

  async componentDidMount() {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval')) || {};
    const { idname = '', token = '' } = storage_session;

    const urlParts = window.location.href.split('-');
    const user_id = urlParts[urlParts.length - 1];
    const { username } = this.props.props.params;

    this.setState({ storage_session, idname, token, user_id, username });

    try {
      const resp = await userStore.getUserProfile();
      if (resp != null) {
        const {
            subscription_details,
            imageUrl,
            username: userName,
            email,
            age,
            occupation,
            education,
            role,
            send_notification,
        } = resp;

        this.setState({
          ValidToken: true,
          subscriptionDetails: subscription_details ? JSON.parse(subscription_details) : [],
          avatarURL: imageUrl || '../img/avatars/defaultProfileImage.jpg',
          userName,
          email,
          age,
          occupation,
          education,
          isLoading: false,
          role,
          send_notification,
        });
      } else {
        this.setState({ ValidToken: false });
      }
    } catch (error) {
      this.setState({ ValidToken: false });
    }
  }

  toggle = () => this.setState((s) => ({ dropdownOpen: !s.dropdownOpen }));
  deleteAccountToggle = () =>
    this.setState((pre) => ({ isShowDeleteConfirmationModal: !pre.isShowDeleteConfirmationModal }));

  clearLocalStorage = () => {
    [
      localStorageKeys.userTokenAndEmail,
      localStorageKeys.selectedLanguage,
      localStorageKeys.selectedMenu,
      localStorageKeys.loginId,
      'userData',
      'landingSource',
    ].forEach((key) => localStorage.removeItem(key));
  };

  render() {
    const {
      isLoading,
      userName,
      email,
      age,
      occupation,
      education,
      send_notification,
      isLoadingUpdateProfile,
    } = this.state;

    return (
      <div className='col-sm-12 col-md-6 col-lg-8 col-xl-9'>
        {isLoading && <Loader />}
        <div className='card minHeight-card'>
          <div className='card-header font-16 d-flex justify-content-between'>
            <span>
              <i className='fa fa-users me-2' /> {language.LC().PROFILE_INFO}
            </span>
          </div>

          <div className='card-block'>
            <div className='form_wrapper'>
              <div className='row'>
                {/* Name */}
                <div className='col-md-12 col-lg-6'>
                  <div className='form_field'>
                    <label>{language.LC().NAME}</label>
                    <div className='input-group'>
                      <span className='input-group-addon'>
                        <i className='fa fa-user' />
                      </span>
                      <input
                        type='text'
                        className='form-control'
                        placeholder={language.LC().USERNAME}
                        value={userName}
                        onChange={this.handleInputChange('userName')}
                        maxLength={30}
                      />
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className='col-md-12 col-lg-6'>
                  <div className='form_field'>
                    <label>{language.LC().EMAIL}</label>
                    <div className='input-group'>
                      <span className='input-group-addon'>
                        <i className='fa fa-envelope' />
                      </span>
                      <input
                        type='email'
                        className='form-control'
                        value={email}
                        disabled
                        onChange={this.handleInputChange('email')}
                      />
                    </div>
                  </div>
                </div>

                {/* Age */}
                <div className='col-md-12 col-lg-6'>
                  <div className='form_field'>
                    <label>{language.LC().AGE}</label>
                    <div className='input-group'>
                      <span className='input-group-addon'>
                        <i className='fa fa-user' />
                      </span>
                      <input
                        type='text'
                        className='form-control'
                        value={age || ''}
                        onChange={this.handleInputChange('age')}
                        maxLength={3}
                      />
                    </div>
                  </div>
                </div>

                {/* Occupation */}
                <div className='col-md-12 col-lg-6'>
                  <div className='form_field'>
                    <label>{language.LC().OCCUPATION}</label>
                    <div className='input-group'>
                      <span className='input-group-addon'>
                        <i className='fa fa-briefcase' />
                      </span>
                      <input
                        type='text'
                        className='form-control'
                        value={occupation || ''}
                        onChange={this.handleInputChange('occupation')}
                        maxLength={40}
                      />
                    </div>
                  </div>
                </div>

                {/* Education */}
                <div className='col-md-12 col-lg-6'>
                  <div className='form_field'>
                    <label>{language.LC().EDUCATION}</label>
                    <div className='input-group'>
                      <span className='input-group-addon'>
                        <i className='fa fa-graduation-cap' />
                      </span>
                      <input
                        type='text'
                        className='form-control'
                        value={education || ''}
                        onChange={this.handleInputChange('education')}
                        maxLength={40}
                      />
                    </div>
                  </div>
                </div>

                {/* Notifications */}
                <div className='col-md-12 col-lg-6'>
                  <div className='form_field'>
                    <label>{language.LC().SEND_NOTIFICATIONS_VIA_EMAIL}</label>
                    <div className='input-group'>
                      <span className='input-group-addon'>
                        <i className='fa fa-cog' />
                      </span>
                      <select
                        className='form-control'
                        value={send_notification}
                        onChange={this.handleInputChange('send_notification')}
                      >
                        <option value={true}>{language.LC().YES}</option>
                        <option value={false}>{language.LC().NO}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex justify-content-between'>
                <button
                  className='btn btn-danger account-delete pointer_class pull-right'
                  onClick={this.deleteAccountToggle}
                >
                  {language.LC().ACCOUNT_DELETE}
                </button>
                <button
                  className='btn btn-primary pointer_class pull-right'
                  onClick={this.updateProfile}
                  disabled={isLoadingUpdateProfile}
                >
                  {isLoadingUpdateProfile ? <i className='fa fa-spinner fa-spin' /> : null}{' '}
                  {language.LC().UPDATE_PROFILE}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <Modal
          isOpen={this.state.isShowDeleteConfirmationModal}
          toggle={this.deleteAccountToggle}
          className={`modal-primary ${this.props.className}`}
        >
          <ModalHeader>
            {language.LC().ACCOUNT_DELETE_ALERT}
            <Button className='close' onClick={this.deleteAccountToggle}>
              ×
            </Button>
          </ModalHeader>
          <ModalBody>
            <div className='text-center'>
              <p style={{ color: 'red' }}>
                <strong>{language.LC().ARE_YOU_SURE_TO_DELETE_THIS_ACCOUNT}</strong>
              </p>
              {renderHTMLContent(
                `<strong>Please Note: </strong> This will <span style='color: #f86c6b;font-weight: bold;'>permanently</span> delete your account including all your data.<br/>
                <p>Your subscriptions/packages will be <span style='color: #f86c6b;font-weight: bold;'>automatically cancelled</span>.`,
                'p',
              )}
              <Button color='primary' onClick={this.deleteAccount}>
                {language.LC().OK}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ProfileInfo;



// WEBPACK FOOTER //
// ./src/views/Profile/ProfileInfo/ProfileInfo.js